import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import HeroSection from "./sectionOne/HeroSection";
import ApiDetails from "./sectionTwo/ApiDetails";

const Index = () => {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <>
      <div data-aos="fade-up" className="m-6">
        <HeroSection />
      </div>

      <div data-aos="fade-left" >
        <ApiDetails />
      </div>
    </>
  );
};

export default Index;
